import request from '@/utils/request'



/**
 *  保存/创建文件
 * @param {*} fileName 文件名
 * @param {*} fileJSON 文件内容
 * @param {*} fileLogo 缩略图
 * @param {*} releaseTime 时间
 * @param {*} remark
 * @param {*} id
 * @param {*} stationId
 * @returns
 */
export function save({ fileName, fileJSON, fileLogo, releaseTime, remark, id, stationId, fileType }) {

  let formData = new FormData()
  formData.append('fileName', fileName)
  formData.append('fileJson', JSON.stringify(fileJSON))
  formData.append('fileLogo', fileLogo)
  formData.append('releaseTime', releaseTime)
  formData.append('remark', remark)
  formData.append('id', id)
  formData.append('stationId', stationId)
  formData.append('fileType', fileType)

  return request({
    url: '/device/topology',
    method: 'post',
    data: formData
  })
}


/**
 * 获取电站拓扑详细信息
 * @param {*} id
 */
export function getTopoById(id) {
  return request({
    url: '/device/topology/' + id,
    method: 'get',
  })
}


/**
 * 删除电站拓扑信息,id可以传多个 用英文逗号隔开
 * @param {*} ids
 * @returns
 */
export function removeTopoById(ids) {
  return request({
    url: '/device/topology/' + ids,
    method: 'delete',
  })
}


/**
 * 获取电站拓扑列表
 * @returns
 */
export function getTopoList(pageNum = 1, pageSize = 10) {
  return request({
    url: '/device/topology/list',
    method: 'get',
    params: {
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

/**
 * 修改电站拓扑发布状态
 * @param {*} params
 * @returns
 */
export function updateState({ fileName, fileJSON, fileLogo, releaseTime, remark, id, fileType, stationId }) {

  let formData = new FormData()
  formData.append('fileName', fileName)
  formData.append('fileJson', JSON.stringify(fileJSON))
  formData.append('fileLogo', fileLogo)
  formData.append('releaseTime', releaseTime)
  formData.append('remark', remark)
  formData.append('id', id)
  formData.append('fileType', fileType)
  formData.append('stationId', stationId)

  return request({
    url: '/device/topology/updateState',
    method: 'post',
    data: formData
  })
}



/**
 * 根据电站ID获取elink和eblock结构数据
 * @param {*} stationId
 * @returns
 */
export function getElinkList(stationId) {
  return request({
    url: `/assetsmng/elink/eLinkList/${Number(stationId)}`,
    method: 'get'
  })
}

/**
 * 根据电站ID和文件类型获取Topo详情
 * @param {*} stationId
 * @param {*} fileType
 * @returns
 */
export function getTopoDetail(stationId, fileType) {
  return request({
    url: `/device/topology/byType`,
    method: 'post',
    data: {
      stationId: stationId,
      fileType: fileType
    }
  })
}


/**
 * 获取自定义原件列表
 * @returns
 */
export function getCustomElements() {
  return request({
    url: `/device/element/list`,
    method: 'get',
  })
}


/**
 * 新增拓扑元件
 * @returns
 */
export function addCustomElement(elementName, enName, elementType, elementPicture) {
  return request({
    url: `/device/element`,
    method: 'post',
    data: {
      elementName,
      enName,
      elementType,
      elementPicture
    }
  })
}

/**
 * 删除拓扑元件
 * @param {*} elementId
 * @returns
 */
 export function deleteCustomElement(elementId) {
  return request({
    url: `/device/element/${elementId}`,
    method: 'delete',
  })
}


/**
 * 上传拓扑背景图片
 * @param {File} bg_picture
 * @returns
 */
 export function uploadImage(bg_picture) {

  let formData = new FormData()
  formData.append('bg_picture', bg_picture, bg_picture.name)

  return request({
    url: `/device/topology/upload`,
    method: 'post',
    data: formData
  })
}


/**
 * 创建以及修改电站拓扑
 * @param {*} data 
 * @returns 
 */
export function postTopology(data) {
  return request({
    url: `/device/v2/station/topology`,
    method: 'post',
    data: data
  })
}


/**
 * 查询电站拓扑
 * @param {*} stationId 
 * @returns 
 */
export function getTopology(stationId) {
  return request({
    url: `/device/v2/station/topology/${stationId}`,
    method: 'get',
  })
}




// /device/v2/station/topology/{stationId}
